module.exports = __webpack_public_path__ + "img/logo.471bc9bd.png";